<template>
  <div class="text-center">
    Please go to
    <a href="https://loadsmart.okta.com/">Okta</a>
    to log in.
  </div>
</template>
